import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegistrarCargaInventarioComponent } from './registrar-carga-inventario-component';


const routes: Routes = [
    { path: '', component: RegistrarCargaInventarioComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes), FormsModule, ReactiveFormsModule],
    exports: [RouterModule]
})
export class RegistrarCargaInventarioRoutingModule { }
